export const cleanValues = (values) => {
  let final = {};

  Object.entries(values).forEach(([key, value]) => {
    if (
      value !== '' &&
      value !== 'Select' &&
      value !== undefined &&
      value !== null
    ) {
      final[key] = value;
    }
  });

  return { ...final };
};
